import cx from 'classnames';
import { BigButton } from '../../common';
import styles from './PlanMainInfoBlock.module.scss';
import Button from '../../components/Button';

function PlanMainInfoBlock({
  style,
  title,
  description,
  amount,
  unit,
  buttonText,
  onClick,
  buttonClassName = '',
  isFreemium,
  allData,
  onSelect,
  designV2 = false,
  buttonType = 'primary', // light
}) {
  return (
    <div className={cx(styles.container, designV2 ? styles.designV2 : '')} style={style}>
      <div className={styles.planInfo}>
        <h5 className={styles.title}>{title}</h5>
        <p className={styles.description}>{description}</p>
        <div className={styles.pricing}>
          {isFreemium ? (
            <>
              <div className={'d-flex gap-1 align-items-end'}>
                <span className={styles.amount}>{amount ?? 'Free'}</span>
              </div>
            </>
          ) : (
            <>
              {!designV2 ? <p className={styles.infoText}>You pay</p> : null}
              <div className={'d-flex gap-1 align-items-end'}>
                <span className={styles.amount}>{amount}</span>
                <span className={styles.unit}>{unit}</span>
              </div>
            </>
          )}
        </div>
      </div>
      {(buttonText || onClick || onSelect) &&
        (designV2 ? (
          <Button
            color={buttonType} // isFreemium ? 'light' : 'primary'
            size="xlg"
            className={`w-100 ${styles.buttonStyle}`}
            onClick={() => (onSelect ? onSelect(allData, buttonText) : onClick(allData))}
            style={{ borderRadius: '10px' }}>
            {buttonText}
          </Button>
        ) : (
          <BigButton
            variant="secondary"
            className={cx('bigButton lf-btn-1 btn-v2', buttonClassName,styles.buttonStyle)}
            buttonTitle={buttonText}
            onClick={() => (onSelect ? onSelect(allData, buttonText) : onClick(allData))}
          />
        ))}
    </div>
  );
}

export default PlanMainInfoBlock;
